export const getVendorBalanceMutation = (builder) => ({
    getVendorBalance: builder.mutation({
      query: ({ user_id }) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/get_vendor_wallet',
          method: 'GET',
          params: { user_id },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });